import * as React from "react";
import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
import { Button } from "@/components/ui/button";
const events = [{
  id: 1,
  date: "12",
  month: "OCT",
  title: "Smash Burger Showdown",
  description: "Witness the ultimate battle of flavors as our chefs compete to create the most intense Punjabi-fusion smash burger ever tasted.",
  link: "/EventsPage"
}, {
  id: 2,
  date: "25",
  month: "OCT",
  title: "Midnight Karahi Night",
  description: "A late-night culinary journey featuring our signature goat karahi, live spice grinding, and traditional clay oven naan.",
  link: "/EventsPage"
}, {
  id: 3,
  date: "05",
  month: "NOV",
  title: "Halal Fusion Workshop",
  description: "Learn the art of blending American grill techniques with authentic Punjabi spices in this exclusive hands-on masterclass.",
  link: "/EventsPage"
}];
export default function UpcomingExperiences() {
  return <section data-section-id="224080" id="the-grill-schedule" className="bg-background text-foreground py-24 px-6 md:px-12 lg:px-24">
      
    </section>;
}